<template>
    <main class="produtos">
        <div class="container px-2 px-md-3 pg-inter-produtos">
            <div class="sombra-direita"></div>
            <div class="sombra-esquerda"></div>
            <div class="principal bg-white my-4">
                <section class="dados-cadastrais">
                    <header class="header-pagina">
                        <h3>Seus dados cadastrais</h3>
                    </header>
                    <div class="container py-3">
                        <h5 class="mt-0">{{ user.nome }}</h5>
                        <span class="font-weight-bold">E-mail:</span> {{ user.email }}<br />
                        <span class="font-weight-bold">CPF:</span>
                        {{ user.cpF_CNPJFormatado }}<br />
                    </div>
                </section>
                <section id="tab_produtos" class="produtos">
                    <header class="header-pagina">
                        <h3>Seus produtos para compra</h3>
                    </header>
                    <div class="alert alert-danger" v-if="pedidoMessage">
                        <p>
                            O pedido
                            <strong>{{ pedidoMessage.numeroItem }}</strong>
                            foi cancelado por falta de pagamento. Os Materiais
                            <strong>
                                {{
                  pedidoMessage.nomeProduto +
                  " (" +
                  pedidoMessage.nomeDestinatario +
                  ")"
                                }}
                            </strong>
                            foram liberados para a realização de uma nova compra.
                        </p>
                    </div>
                    <!--PRODUTOS NORMAIS-->
                    <div class="vitirine-material-didatico"
                         v-for="_ in collectionTipoProdutoNormal">
                        <!--CERTIFICAÇÕES-->
                        <div class="container py-3 vitrine-produtos">
                            <div class="d-flex justify-content-between">
                                <h5>
                                    <strong>{{ _.tipoProduto ? _.tipoProduto.nome : "" }}</strong>
                                </h5>
                                <!--<div class="botoes-view" v-if="cnaStore">
                                    <button type="button"
                                            class="btn btn-link px-1"
                                            @click="viewLinha = true">
                                        <span class="material-icons"> view_headline </span>
                                    </button>
                                    <button type="button"
                                            class="btn btn-link px-1"
                                            @click="viewLinha = false">
                                        <span class="material-icons"> view_column </span>
                                    </button>
                                </div>-->
                            </div>
                            <hr class="mt-1" />
                            <div class="row p-2">
                                <div class="mb-4 col-md-3 view-col"
                                     v-if="!viewLinha"
                                     v-for="item in _.collectionPessoaProduto">
                                    <div class="card h-100 produto">
                                        <div class="img-produto overflow-hidden position-relative">
                                            <img class="card-img-produto"
                                                 :src="item.produto.imagem"
                                                 width="100%"
                                                 :alt="item.produto.nome" />
                                            <div v-if="item.produto.preVenda" class="overlay"></div>
                                            <div v-if="item.produto.preVenda" class="pre-venda-text">
                                                <span>&emsp;PRÉ-VENDA&emsp;</span>
                                            </div>
                                        </div>
                                        <h5 class="card-title p-2">
                                            {{ item.escola ? item.escola.nomeEscola : "" }}
                                        </h5>
                                        <div class="card-body p-2 text-center">
                                            <p class="card-text">{{ item.produto.nome }}</p>
                                            <span class="descricao-produto d-flex flex-column">
                                                <p v-html="item.produto.descricao"></p>
                                                <span class="text-right w-100">
                                                    <a @click="showModal(item.produto)">Saiba mais...</a>
                                                </span>
                                            </span>
                                            <p class="card-text">{{ item.nomeDestinatario }}</p>
                                            <p class="card-text">
                                                {{ item.promocao ? item.promocao.nome : "" }}
                                            </p>

                                            <!--<p class="card-text">Compre até {{ item.dataLimiteCompra }}</p>-->
                                        </div>
                                        <div class="card-body p-2 text-right"
                                             v-if="item.collectionPessoaProdutoSubItem && item.collectionPessoaProdutoSubItem.length > 0">
                                            <button class="btn btn-link"
                                                    @click="
                          openDetalhesSubitem(
                            item.collectionPessoaProdutoSubItem
                          )
                        ">
                                                <small>
                                                    Lote: #{{ item.referenciaExternoId }}
                                                    <i class="fa fa-search"></i>
                                                </small>
                                            </button>
                                        </div>
                                        <div class="card-body p-2 text-center"
                                             v-if="
                        item.permitirQuantidade &&
                        item.permitirQuantidade == true
                      ">
                                            <!--<p class="card-text">
            Preço Un: <strong> R$ {{ item.valor }}</strong>
        </p>-->
                                            <p class="card-text">
                                                Total a Prazo: <strong>{{ item.precoTotal }}</strong>
                                            </p>
                                            <div style="display: inline-block">
                                                <button class="btn btn-sm btn-danger"
                                                        @click="AddRemoveItem(item, 'remove')">
                                                    <i class="fa fa-minus"></i>
                                                </button>
                                                <input class="mx-2 text-center"
                                                       style="width: 45px"
                                                       v-model="item.quantidade"
                                                       @change="updateUnidade(item)"
                                                       type="number" />
                                                <button class="btn btn-sm btn-success"
                                                        @click="AddRemoveItem(item, 'add')">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="row aceitar-regulamento"
                                             v-if="
                        item.produto.regulamentoId &&
                        !item.dataLimiteCompraExpirada &&
                        item.produto.ativo &&
                        item.produto.disponivel &&
                        item.produto.tipoProduto.auxTipoProdutoId != 1
                      ">
                                            <div class="col-8 text-right">
                                                <a class="hyperlink text-dark"
                                                   @click="openRegulamento(item)">Ver Regulamento</a>
                                            </div>
                                            <div class="col-4">
                                                <i v-if="item.temAceiteRegulamento"
                                                   class="material-icons text-success">check_circle</i>
                                                <i v-else class="material-icons text-danger">cancel</i>
                                            </div>
                                        </div>
                                        <div class="card-footer text-muted p-0 mt-3">
                                            <div v-if="item.permitirQuantidade">
                                                <button type="button"
                                                        @click="confirmaRemover(item)"
                                                        class="btn btn-raised btn-danger btn-block m-0">
                                                    Remover
                                                </button>
                                            </div>
                                            <div v-else>

                                                <button type="button"
                                                        v-if="
                            item.dataLimiteCompraExpirada &&
                            !item.permitirQuantidade
                          "
                                                        class="btn btn-raised btn-secondary btn-block m-0"
                                                        disabled>
                                                    Expirado
                                                </button>
                                                <button type="button"
                                                        v-else-if="
                            !item.produto.ativo || !item.produto.disponivel
                          "
                                                        class="btn btn-raised btn-secondary btn-block m-0"
                                                        disabled>
                                                    Não Disponível
                                                </button>
                                                <button type="button"
                                                        v-else-if="item.selecionado"
                                                        @click="addCarrinho(item)"
                                                        class="btn btn-raised btn-success btn-block m-0">
                                                    Selecionado
                                                </button>
                                                <button type="button"
                                                        v-else
                                                        @click="addCarrinho(item)"
                                                        class="btn btn-raised btn-secondary btn-block m-0">
                                                    Selecionar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="view-line w-100" v-if="viewLinha">
                                    <table class="table table-borderless w-100">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Produto</th>
                                                <th>Quantidade</th>

                                                <!--<th class="text-nowrap">Preço Unitário</th>-->
                                                <th>Total a Prazo</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in _.collectionPessoaProduto">
                                                <td>
                                                    <img class="card-img-produto"
                                                         :src="item.produto.imagem"
                                                         width="100%"
                                                         :alt="item.produto.nome" />
                                                </td>
                                                <td class="w-75">
                                                    {{ item.produto.nome }}
                                                </td>
                                                <td>
                                                    <div style="display: inline-block"
                                                         class="d-flex flex-row">
                                                        <button class="btn btn-sm btn-danger"
                                                                v-if="!item.cnaStoreViaBox"
                                                                @click="AddRemoveItem(item, 'remove')">
                                                            <i class="fa fa-minus"></i>
                                                        </button>
                                                        <input class="mx-2 text-center"
                                                               style="width: 45px"
                                                               :disabled="item.cnaStoreViaBox"
                                                               v-model="item.quantidade"
                                                               @change="updateUnidade(item)"
                                                               type="number" />
                                                        <button class="btn btn-sm btn-success"
                                                                v-if="!item.cnaStoreViaBox"
                                                                @click="AddRemoveItem(item, 'add')">
                                                            <i class="fa fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </td>

                                                <!--<td class="text-nowrap">
                                                    <strong> R$ {{ item.valor }}</strong>
                                                </td>-->
                                                <td class="text-nowrap">
                                                    <strong> {{ item.precoTotal }}</strong>
                                                </td>
                                                <td>
                                                    <button type="button"
                                                                v-if="!item.cnaStoreViaBox"
                                                            @click="confirmaRemover(item)"
                                                            class="btn btn-link m-0 remover">
                                                        <span class="material-icons text-danger">
                                                            close
                                                        </span>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!--FIM CERTIFICAÇÕES-->
                    </div>

                    <!-- Botão para produtos normais -->
                    <div class="vitirine-material-certificacao"
                         v-if="idsSelecionadosNormais.length > 0">
                        <div class="container py-3 vitrine-produtos text-center">
                            <button type="button"
                                    class="btn btn-raised btn-danger my-3"
                                    @click="comprar()">
                                Seguir para a compra
                            </button>
                        </div>
                    </div>

                    <!-- Botão para produtos de troca - Prosseguir com a compra (normal) -->
                    <!--<div class="vitirine-material-certificacao"
                         v-if="idsSelecionadosNormais.length > 0">
                        <div class="container py-3 vitrine-produtos text-center">
                            <button type="button"
                                    class="btn btn-raised btn-danger my-3"
                                    @click="comprar(true, false)">
                                Prosseguir com a compra
                            </button>
                        </div>
                    </div>-->

                    <!--CNA STORE - TROCA (EhTroca = true)-->
                    <div class="vitirine-material-didatico" v-if="produtosTroca.length > 0">
                        <div class="container py-3 vitrine-produtos">
                            <div class="d-flex justify-content-between">
                                <h5>
                                    <strong>CNA Store - Troca</strong>
                                </h5>
                            </div>
                            <hr class="mt-1" />
                            <div class="row p-2">
                                <div class="view-line w-100">
                                    <table class="table table-borderless w-100">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Produto</th>
                                                <th>Quantidade</th>
                                                <th>Total a Prazo</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in produtosTroca" :key="item.pessoaProdutoId">
                                                <td>
                                                    <img class="card-img-produto"
                                                         :src="item.produto.imagem"
                                                         width="100%"
                                                         :alt="item.produto.nome" />
                                                </td>
                                                <td class="w-75">
                                                    {{ item.produto.nome }}
                                                </td>
                                                <td>
                                                    <div class="d-flex align-items-center" v-if="item.permitirQuantidade && item.permitirQuantidade == true">
                                                        <button class="botao-qtd btn btn-sm btn-link"
                                                                @click="AddRemoveItem(item, 'remove')">
                                                            <span class="material-icons">remove</span>
                                                        </button>
                                                        <input type="number"
                                                               class="form-control mx-1"
                                                               style="width: 60px;"
                                                               v-model="item.quantidade"
                                                               @blur="updateUnidade(item)" />
                                                        <button class="botao-qtd btn btn-sm btn-link"
                                                                @click="AddRemoveItem(item, 'add')">
                                                            <span class="material-icons">add</span>
                                                        </button>
                                                    </div>
                                                    <span v-else>{{ item.quantidade || 1 }}</span>
                                                </td>
                                                <td class="text-nowrap">
                                                    <strong>{{ item.precoTotal }}</strong>
                                                </td>
                                                <td class="text-center">
                                                    <button type="button"
                                                            @click="confirmaRemover(item)"
                                                            class="btn btn-link m-0 text-danger">
                                                        <span class="material-icons">close</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <!-- Botão TROCA dentro do bloco -->
                            <div class="text-center py-3">
                                <button type="button"
                                        class="btn btn-raised btn-warning"
                                        @click="comprar(true, true)">
                                    Prosseguir com a compra TROCA
                                </button>
                            </div>
                        </div>
                    </div>
                    <!--FIM CNA STORE - TROCA-->

                    <div v-if="!textoBuscandoInteresses && collectionTipoProduto.length == 0">
                        <p class="text-center py-4">Sem produtos para compra</p>
                    </div>

                    <div v-if="textoBuscandoInteresses">
                        <p class="text-center py-4">{{ textoBuscandoInteresses }}</p>
                    </div>
                </section>
                <!--FIM PRODUTOS-->
                <!--MEUS PEDIDOS EXPIRADOS-->
                <section class="vitirine-material-expirados"
                         v-if="produtosExpirados.length > 0">
                    <header class="header-pagina">
                        <h3>Seus produtos expirados</h3>
                    </header>

                    <div class="vitirine-material-didatico">
                        <div class="container py-3 vitrine-produtos">
                            <div class="row p-2" v-if="produtosExpirados.length > 0">
                                <div class="mb-4 col-md-3" v-for="item in produtosExpirados">
                                    <div class="card h-100">
                                        <div class="img-produto overflow-hidden">
                                            <img class="card-img-produto"
                                                 :src="item.produto.imagem"
                                                 width="100%"
                                                 :alt="item.produto.nome" />
                                        </div>
                                        <h5 class="card-title p-2">
                                            {{ item.escola ? item.escola.nomeEscola : "" }}
                                        </h5>
                                        <div class="card-body text-center">
                                            <p class="card-text">
                                                {{ item.produto ? item.produto.nome : "" }}
                                            </p>
                                            <p class="card-text" style="color: darkred">
                                                Expirado dia {{ item.dataLimiteCompra }}
                                            </p>
                                            <p class="card-text">{{ item.nomeDestinatario }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="produtosExpirados.length == 0">
                                <p class="text-center py-4">Sem produtos expirados</p>
                            </div>
                        </div>
                    </div>
                </section>
                <!--FIM MEUS PEDIDOS EXPIRADOS-->
                <!--MEUS PEDIDOS-->
                <pedidos></pedidos>
                <!--FIM MEUS PEDIDOS-->
            </div>
        </div>

        <b-modal :no-close-on-backdrop="true"
                 size="lg"
                 :no-close-on-esc="true"
                 centered
                 v-model="dialogRegulamento"
                 :hide-footer="true"
                 title="Regulamento">
            <regulamento v-if="dialogRegulamento"
                         :pessoa-produto="pessoaProduto"
                         @on-saved="onSavedRegulamento()"
                         @on-back="hideAll()" />
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 size="md"
                 :no-close-on-esc="true"
                 centered
                 v-model="confirmRemoverCarrinho"
                 :hide-footer="true"
                 title="Confirmação">
            <div class="modal-body">
                <p>
                    <strong>Tem certeza que deseja limpar seu carrinho?</strong>
                </p>                
                <div class="row w-100 mt-5">
                    <div class="col-6 text-left">
                        <button class="btn btn-raised btn-secondary" @click="hideAll()">
                            Cancelar
                        </button>
                    </div>
                    <div class="col-6 text-right">
                        <button class="btn btn-raised btn-danger"
                                @click="limparCarrinho()">
                            Limpar Carrinho
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 size="md"
                 :no-close-on-esc="true"
                 centered
                 v-model="confirmRemover"
                 :hide-footer="true"
                 title="Confirmação">
            <div class="modal-body">
                <p>
                    <strong>Tem certeza que deseja remover o item do carrinho?</strong>
                </p>
                <p>{{ pessoaProduto.produto.nome }}</p>
                <div class="row w-100 mt-5">
                    <div class="col-6 text-left">
                        <button class="btn btn-raised btn-secondary" @click="hideAll()">
                            Cancelar
                        </button>
                    </div>
                    <div class="col-6 text-right">
                        <button class="btn btn-raised btn-danger"
                                @click="deletePessoaProduto(pessoaProduto)">
                            Remover
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 size="xl"
                 :no-close-on-esc="true"
                 centered
                 v-model="dialogDetalhesSubitem"
                 :hide-footer="true"
                 title="Detalhes do Lote">
            <div class="table-responsive standard-table mb-3">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Nome:</th>
                            <th>Valor:</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(subItem, index) in pessoaProdutoSubItems">
                            <td>{{ index + 1 }}</td>
                            <td>{{ subItem.nomeDestinatario }}</td>
                            <td>{{ formatPrice(subItem.valor) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-modal>

        <b-modal ref="detalhe-produto"
                 size="lg"
                 hide-footer
                 title="Detalhes do produto"
                 v-model="exibirModalProduto">
            <b-media>
                <template #aside>
                    <img :src="modelProduto.imagem"
                         alt="Media Aside"
                         class="img-produto-modal" />
                </template>
                <h5 class="mt-0 text-danger d-flex justify-content-between align-items-center border-bottom">
                    <span>{{ modelProduto.nome }}</span>
                </h5>

                <p class="produto-descricao-texto" v-html="modelProduto.descricao"></p>
            </b-media>
        </b-modal>

        <!-- Ajuste task 8575 -->
        <div v-if="dialogCompraParcelamentoEscola">
            <b-modal :no-close-on-backdrop="true"
                     size="xl"
                     :no-close-on-esc="true"
                     centered
                     v-model="dialogCompraParcelamentoEscola"
                     :hide-footer="true"
                     title="Atenção">
                <div class="table-responsive standard-table mb-3">
                    <p>{{ menssagemParcelamentoEscola }}</p>
                </div>
                <button type="button"
                        class="btn btn-outline-danger float-left"
                        @click="dialogCompraParcelamentoEscola = false">
                    <span>Fechar</span>
                </button>
                <button type="button"
                        class="btn btn-outline-success float-right"
                        @click="goCarrinho()">
                    <span>Prosseguir</span>
                </button>
            </b-modal>
        </div>
        <!-- fim-->
    </main>
</template>
<script>
    import { Api } from "@/common/api";
    import auth from "@/common/auth";
    import tutorStep from "@/common/tutor-step";
    import Cache from "@/common/cache";
    import base from "@/common/base";
    import regulamento from "./regulamento";
    import pedidos from "./pedidos";
    import Global from "@/common/global";

    export default {
        name: "home",
        components: { regulamento, pedidos },
        mixins: [base],
        data() {
            return {
                confirmRemover: false,
                confirmRemoverCarrinho: false,
                startTutorialAuto: true,
                dialogDetalhesSubitem: false,
                textoBuscandoInteresses: null,
                dialogRegulamento: false,
                collectionTipoProduto: [],
                modelProduto: {},
                exibirModalProduto: false,
                pessoaProduto: {
                    produto: {},
                },
                produtosExpirados: {},
                pessoa: {},
                pedidoMessage: null,
                pessoaProdutoSubItems: {},
                dialogCompraParcelamentoEscola: false,
                menssagemParcelamentoEscola: "",
                cnaStore: false,
                loginCnaStore: "",

                viewLinha: true,
            };
        },
        computed: {
            idsSelecionados() {
                let _collectionPessoaProduto = this.collectionTipoProduto.reduce(
                    (pn, u) => [...pn, ...u.collectionPessoaProduto],
                    []
                );
                return _collectionPessoaProduto
                    .filter((_) => _.selecionado)
                    .map((_) => _.pessoaProdutoId);
            },
            // IDs de produtos normais selecionados (EhTroca = false ou null)
            idsSelecionadosNormais() {
                let _collectionPessoaProduto = this.collectionTipoProduto.reduce(
                    (pn, u) => [...pn, ...u.collectionPessoaProduto],
                    []
                );
                return _collectionPessoaProduto
                    .filter((_) => _.selecionado && !_.ehTroca)
                    .map((_) => _.pessoaProdutoId);
            },
            // IDs de produtos de troca selecionados (EhTroca = true)
            idsSelecionadosTroca() {
                let _collectionPessoaProduto = this.collectionTipoProduto.reduce(
                    (pn, u) => [...pn, ...u.collectionPessoaProduto],
                    []
                );
                return _collectionPessoaProduto
                    .filter((_) => _.selecionado && _.ehTroca === true)
                    .map((_) => _.pessoaProdutoId);
            },
            // Produtos normais (EhTroca = false ou null) - agrupados por tipo
            collectionTipoProdutoNormal() {
                return this.collectionTipoProduto.map(tipoProduto => ({
                    ...tipoProduto,
                    collectionPessoaProduto: tipoProduto.collectionPessoaProduto.filter(item => !item.ehTroca)
                })).filter(tipoProduto => tipoProduto.collectionPessoaProduto.length > 0);
            },
            // Produtos de troca (EhTroca = true) - lista plana para o bloco CNA Store - Troca
            produtosTroca() {
                return this.collectionTipoProduto.reduce(
                    (acc, tipoProduto) => [...acc, ...tipoProduto.collectionPessoaProduto.filter(item => item.ehTroca === true)],
                    []
                );
            },
        },
        methods: {
            showModal(model) {
                this.modelProduto = model;
                this.exibirModalProduto = true;
            },
            openDetalhesSubitem(collectionPessoaProdutoSubItem) {
                this.pessoaProdutoSubItems = collectionPessoaProdutoSubItem;
                this.dialogDetalhesSubitem = true;
            },
            /**
             * Método unificado para comprar produtos
             * @param {boolean} ehTroca - Se true, usa produtos de troca; se false, usa produtos normais
             * @param {boolean} ehCarrinhoStoreTroca - Se true, usa AttributeBehavior = CarrinhoStoreTroca no GET
             */
            comprar(ehTroca = false, ehCarrinhoStoreTroca = false) {
                const ids = ehTroca 
                    ? this.produtosTroca.map(p => p.pessoaProdutoId) 
                    : this.idsSelecionadosNormais;
                const temProdutos = ehTroca 
                    ? this.produtosTroca.length > 0 
                    : this.idsSelecionadosNormais.length > 0;

                if (temProdutos && this.cnaStore) {
                    new Api("pedido/GetValidacaoPedido")
                        .get()
                        .then(
                            (result) => {
                                if (result.data.valid) {
                                    if (result.data.warning) {
                                        this.dialogCompraParcelamentoEscola = true;
                                        this.menssagemParcelamentoEscola = result.data.warning;
                                    } else {
                                        this.navegarCarrinho(ids, ehCarrinhoStoreTroca);
                                    }
                                }
                            },
                            (err) => {
                                this.defaultErrorResult(err, true);
                            }
                        );
                }
                else {
                    new Api("pedido/GetValidacaoPedido")
                        .get({ ids: ids })
                        .then(
                            (result) => {
                                if (result.data.valid) {
                                    if (result.data.warning) {
                                        this.dialogCompraParcelamentoEscola = true;
                                        this.menssagemParcelamentoEscola = result.data.warning;
                                    } else {
                                        this.navegarCarrinho(ids, ehCarrinhoStoreTroca);
                                    }
                                }
                            },
                            (err) => {
                                this.defaultErrorResult(err, true);
                            }
                        );
                }
            },
            limparCarrinho() {
                new Api("PessoaProduto/LimparCarrinhoCnaStore")
                    .delete()
                    .then(
                        (result) => {
                            this.defaultSuccessResult("Produto(s) removido!");
                            this.hideAll();
                            this.showLoading();
                            this.getInteresses();
                        },
                        (err) => {
                            this.defaultErrorResult(err);
                        }
                    );
            },
            /**
             * Navega para o carrinho com os IDs especificados
             * @param {Array} ids - IDs dos produtos
             * @param {boolean} ehCarrinhoStoreTroca - Se true, seta flag para usar CarrinhoStoreTroca
             */
            navegarCarrinho(ids, ehCarrinhoStoreTroca = false) {
                if (!this.cnaStore) {
                    let query = { id: ids };
                    if (ehCarrinhoStoreTroca) {
                        query.ehTroca = true;
                    }
                    this.$router.push({
                        path: "carrinho",
                        query: query
                    });
                }
                else {
                    localStorage.setItem("carrinho", ids);
                    // Remove qualquer valor antigo primeiro
                    localStorage.removeItem("carrinhoEhTroca");
                    
                    let query = {};
                    if (ehCarrinhoStoreTroca) {
                        localStorage.setItem("carrinhoEhTroca", "true");
                        query.ehTroca = true;
                    }
                    this.$router.push({
                        path: "carrinho",
                        query: query
                    });
                }
            },
            // Mantido para o modal de parcelamento escola
            goCarrinho() {
                this.navegarCarrinho(this.idsSelecionadosNormais);
            },

            addCarrinho(item) {
                let sel = !item.selecionado;
                const tipoSelecionado = item.produto.tipoProduto.auxTipoProdutoId;
                let escolaId = item.escolaId;

                this.collectionTipoProduto.forEach(tp => {
                    tp.collectionPessoaProduto.forEach(pp => {
                        const tipoAtual = tp.tipoProduto.auxTipoProdutoId;

                        if (tipoSelecionado === 1) {
                            // Se o item clicado for do tipo 1
                            if (tipoAtual === 1 && pp.escolaId == escolaId) {
                                pp.selecionado = sel; // Marca ou desmarca todos do tipo 1
                            } else {
                                pp.selecionado = false; // Desmarca todos os outros tipos
                            }
                        } else {
                            // Se o item clicado NÃO for tipo 1
                            if (tipoAtual === 1) {
                                pp.selecionado = false; // Desmarca todos os do tipo 1
                            } else if (pp === item) {
                                // Só mexe no item clicado (se não for tipo 1)
                                if (item.temAceiteRegulamento) {
                                    pp.selecionado = sel;
                                } else {
                                    this.openRegulamento(item);
                                }
                            }
                            // Não mexe nos outros do mesmo tipo
                        }
                    });
                });
            },
            onSavedRegulamento() {
                this.dialogRegulamento = false;
                this.addCarrinho(this.pessoaProduto);
            },
            hideAll() {
                this.dialogRegulamento = false;
                this.dialogDetalhesSubitem = false;
                this.confirmRemover = false;
                this.confirmRemoverCarrinho = false;
            },
            openRegulamento(item) {
                this.pessoaProduto = item;
                this.dialogRegulamento = true;
            },
            postInteresses() {
                this.showLoading();
                this.textoBuscandoInteresses =
                    "Aguarde, estamos buscando seus produtos para compra...";
                new Api("pessoaproduto/ObterPessoaProdutoCompraSistemaOrigem")
                    .post()
                    .then(
                        (data) => {
                            this.getInteresses();
                            //this.getExpirados();
                        },
                        (err) => {
                            this.getInteresses();
                            //this.getExpirados();
                            this.defaultErrorResult(err);
                        }
                    );
            },
            getInteresses() {
                this.showLoading();
                this.textoBuscandoInteresses =
                    "Ótimo, encontramos seus produtos... Mais um segundinho, estamos processando os preços, promoções e descontos =)";
                new Api("pessoaproduto/GetProdutoInteresse").get().then(
                    (result) => {
                        this.textoBuscandoInteresses = null;
                        result.dataList = result.dataList.map((_) => {
                            _.collectionPessoaProduto = _.collectionPessoaProduto.map((__) => {

                                // Primeiro verifica se é produto de troca
                                if (__.ehTroca === true) {
                                    __.selecionado = true; // Produtos de troca sempre selecionados
                                } else if (__.permitirQuantidade && __.permitirQuantidade == true) {
                                    __.selecionado = true;
                                } else {
                                    __.selecionado = false;
                                }

                                //CNA STORE VIA BOX
                                if (__.sistemaOrigemId == 6 && __.produto.tipoProdutoId == 3) {
                                    __.cnaStoreViaBox = true;
                                    if (!__.ehTroca) { // Só marca como selecionado se NÃO for troca
                                        __.selecionado = true;
                                    }
                                }

                                //var contemTipoNaoMD = _.collectionPessoaProduto.filter(x => x.produto.tipoProdutoId != 1)

                                //if (contemTipoNaoMD.length < 1 && __.sistemaOrigemId == 3 && __.produto.disponivel && __.produto.ativo && __.produto.tipoProdutoId == 1) 
                                //    __.selecionado = true;

                                __.precoTotal = Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                }).format(__.valor * __.quantidade);
                                return __;
                            });
                            return _;
                        });
                        this.collectionTipoProduto = result.dataList;
                        
                        // Se há produtos de troca, desmarcar todos os produtos normais
                        const temProdutosTroca = this.collectionTipoProduto.some(tp => 
                            tp.collectionPessoaProduto.some(pp => pp.ehTroca === true)
                        );
                        
                        if (temProdutosTroca) {
                            this.collectionTipoProduto.forEach(tp => {
                                tp.collectionPessoaProduto.forEach(pp => {
                                    // Desmarcar produtos normais se houver produtos de troca
                                    if (!pp.ehTroca) {
                                        pp.selecionado = false;
                                    }
                                });
                            });
                        }
                        
                        //console.log("Produtos....", this.collectionTipoProduto);
                        this.hideLoading();

                        if (this.startTutorialAuto) this.startTutorial();
                    },
                    (err) => {
                        this.textoBuscandoInteresses =
                            "Ops, não foi possível carregar seus produtos. Informe a mensagem acima para a sua escola!";
                        this.defaultErrorResult(err);
                    }
                );

                if (this.cnaStore == false) {
                    this.viewLinha = false;
                }
            },
            getExpirados() {
                this.showLoading();
                new Api("pessoaproduto")
                    .get({
                        somenteExpirados: true,
                        CpfCNPJComprador: this.user.cpF_CNPJ,
                        pessoaCNAId: auth.currentUser().pessoaCNAId,
                    })
                    .then(
                        (data) => {
                            this.produtosExpirados = data.dataList;
                        },
                        (err) => {
                            this.defaultErrorResult(err);
                        }
                    );
            },
            getWarningPedido() {
                new Api("pessoaProduto/getwarningmessagepedido").get().then(
                    (data) => {
                        this.pedidoMessage = data.data;
                    },
                    (err) => {
                        this.defaultErrorResult(err);
                    }
                );
            },
            startTutorial() {
                //console.log(this.startTutorialAuto);
                var steps = [
                    {
                        element: ".dados-cadastrais",
                        intro:
                            "Olá, verifique se seus dados estão corretos, qualquer informação diferente, entre em contato com sua escola",
                    },
                    {
                        element: ".logo-circulo",
                        intro: "Sempre que quiser voltar para a home, é só clicar aqui",
                    },
                    {
                        element: ".menu-header",
                        intro:
                            "Aqui voce pode acessar os seus dados completos, alterar sua senha e ver seus pedidos",
                    },
                    {
                        element: ".produto",
                        intro:
                            "Aqui estão os seus produtos para compra, é só clicar em SELECIONAR e depois clicar em COMPRAR",
                    },
                    {
                        element: "#tab_pedidos",
                        intro: "Seus pedidos realizados irão ser exibidos aqui",
                    },
                ];

                //console.log(steps);

                tutorStep.startManual("TUTOR_HOME", steps);
            },
            getConfiguracoes() {
                new Api("configuracoes").get().then(
                    (data) => {
                        if (data && data.dataList) {
                            if (data.dataList.length > 0) {
                                this.startTutorialAuto = data.dataList[0].exibirTutorialAuto;
                            }
                        } else {
                            this.startTutorialAuto = true;
                        }
                    },
                    (err) => {
                        this.startTutorialAuto = true;
                    }
                );
            },
            updateUnidade(item) {
                //this.showLoading();
                if (item.quantidade < 1) {
                    item.quantidade = 1;
                }
                this.updateQuantidade(item);
                item.precoTotal = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(item.valor * item.quantidade);
            },
            AddRemoveItem(item, addOrRemove) {
                //this.showLoading();
                if (addOrRemove == "add") {
                    item.quantidade = parseInt(item.quantidade) + 1;
                } else {
                    if (parseInt(item.quantidade) > 1) {
                        item.quantidade = parseInt(item.quantidade) - 1;
                    }
                }
                item.precoTotal = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(item.valor * item.quantidade);
                this.updateQuantidade(item);
            },
            updateQuantidade(item) {
                new Api("pessoaProduto/AtualizaQuantidade").put(item).then(
                    (result) => {
                        this.hideLoading();
                    },
                    (err) => {
                        this.hideLoading();
                        this.defaultErrorResult(err);
                    }
                );
            },
            confirmaRemover(item) {
                this.confirmRemover = true;
                this.pessoaProduto = item;
            },
            confirmaRemoverCarrinho() {
                this.confirmRemoverCarrinho = true;
            },
            deletePessoaProduto(item) {
                            this.showLoading();
                new Api("PessoaProduto/RemoverPessoaProdutoCnaStore")
                    .delete({ pessoaProdutoId: item.pessoaProdutoId })
                    .then(
                        (result) => {
                            this.defaultSuccessResult("Produto removido!");
                            this.hideAll();
                            this.showLoading();
                            this.getInteresses();
                        },
                        (err) => {
                            this.defaultErrorResult(err);
                        }
                    );
            },

        },
        async mounted() {
            await this.getConfiguracoes();
            //console.log(this.startTutorialAuto);
            //voltar antes de publicar
            this.postInteresses();
            this.$eventHub.$on("start-tutorial", () => {
                this.startTutorial();
            });

            this.cnaStore = Cache.get(auth.ehCnaStore_key) == "true" ? true : false;
            this.loginCnaStore = Cache.get("LOGIN_CNA_STORE");
            //console.log("o q tem aqui",this.loginCnaStore);
            if (this.cnaStore && this.loginCnaStore == null) {
                Cache.add("LOGIN_CNA_STORE", "1");
                window.location.href = "/cnastore";
                //console.log("passou aqui cnastore");
            }
            // comentar antes de publicar
            //this.getInteresses();
            //this.getWarningPedido();
        },
    };
</script>

<style lang="scss">
.view-line {
  tbody {
    td {
      vertical-align: middle;

      .card-img-produto {
        width: 48px;
        max-width: none;
        top: 0;
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }
  }
}

</style>